import RichText from '@eneco/components/RichText/RichText';
import { Image } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const MoveFileCreatedCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();
  return (
    <StyledDashboardBlock>
      <RichText html={fields.moveFileCreatedCard?.description.value || 'Description [not in Sitecore]'} />
      <Image
        src={fields.moveFileCreatedCard?.image.value.formats[0]?.src}
        alt={fields.moveFileCreatedCard?.image.value.alt}
      />
      <DashboardLink
        href={fields.moveFileCreatedCard?.link.value.href}
        emphasis="high"
        trackingComponentName="move_file_created_link"
        trackingComponentType="dashboard_link">
        {fields.moveFileCreatedCard?.link.value.text || 'Link [not in Sitecore]'}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
